import React from 'react'
import './Card.css'
import { useContext } from "react";
import { themeContext } from '../../Context';



const Card = ({emoji,heading,details}) => {
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;
  return (
    <div className="card">
        <img src={emoji} alt=''/>
        <span>{heading}</span>
        <span style = {{color : darkMode? 'white': ''}}>{details}</span>
        <a href='https://www.linkedin.com/in/benjamin-david-dawson-2498261a3/' target={'_blank'} rel="noopener noreferrer">
        <button className="c-button">LEARN MORE</button>
        </a>
    </div>
  )
}

export default Card